import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  toast: {
    display: "flex",
    alignItems: "flex-start",
    width: 320,
    marginRight: 16,
    padding: "6px 16px",
    position: "absolute",
    right: "24px",
    top: "19px",
    color: "#fff",
    borderRadius: "4px",
    boxShadow:
      "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)",
  },
  success: {
    backgroundColor: "#238c4f",
  },
  info: {
    backgroundColor: "#4056c7",
  },
  icon: {
    fontSize: 22,
    marginRight: 12,
    marginTop: 7,
  },
  message: {
    flex: "1 1 0",
    minWidth: 0,
    padding: "8px 0",
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: "0.15px",
  },
  close: {
    color: "#fff",
    marginLeft: 8,
    marginTop: 4,
    padding: 5,
  },
}));
